import { TemplateElement, html, defineElement, when, classMap } from '@webtides/element-js';
import '../../../chip/chip.js';
import '../../../product-card/product-card.js';

/**
 * @typedef {Object} ProductCardsProperties
 * @property {string} headline
 * @property {string} subline
 * @property {ProductCardsProperties[]} products
 */
export default class ProductCards extends TemplateElement {
    properties() {
        return {
            headline: '',
            subline: '',
            products: [],
        };
    }

    template() {
        const gridClasses = {
            'md:w-6/12 md:mx-auto md:grid-cols-1': this.products?.length === 1,
            'md:w-8/12 md:mx-auto md:grid-cols-2': this.products?.length === 2,
            'md:grid-cols-3': this.products?.length >= 3,
        };
        return html`
            <div class="flex flex-col">
                ${when(
                    this.headline,
                    html`
                        <h2
                            class="flex-headline2-medium flex-scale-small text-green-medium text-center text-balance mb-0"
                        >
                            ${this.headline}
                        </h2>
                    `,
                )}
                ${when(
                    this.subline,
                    html`
                        <p class="flex-headline3-regular flex-scale-small text-center text-balance mb-0">
                            ${this.subline}
                        </p>
                    `,
                )}
                <div class="relative h-full grid gap-flex-xs mt-fix-m lg:mt-fix-l ${classMap(gridClasses)}">
                    ${this.products.map(
                        (product, index) => html`
                            <mb-product-card
                                class="h-full"
                                headline="${product.title}"
                                text="${product.text}"
                                .benefits="${product.benefits}"
                                .link="${product.link}"
                            ></mb-product-card>
                        `,
                    )}
                </div>
            </div>
        `;
    }
}

defineElement('mb-product-cards', ProductCards);
